import * as React from "react";
import TextareaAutosize from "@mui/material/TextareaAutosize";

interface ResizableTextareaProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  minRows?: number;
  maxRows?: number;
  placeholder?: string;
  colors: any;
  reduxTheme: any;
}

const ResizableTextarea: React.FC<ResizableTextareaProps> = ({
  label,
  value,
  onChange,
  minRows = 3,
  maxRows = 12,
  placeholder,
  colors,
  reduxTheme,
}) => {
  return (
    <TextareaAutosize
      aria-label={`${label.toLowerCase()} notes`}
      minRows={minRows}
      maxRows={maxRows}
      placeholder={placeholder || `Enter ${label.toLowerCase()} notes here...`}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={{
        width: "100%",
        fontSize: "14px",
        padding: "12px",
        borderRadius: "8px",
        color: colors.primary[100],
        backgroundColor: "transparent",
        border: `1px solid ${reduxTheme.primary_colors[300]}`,
        outline: "none",
        lineHeight: "1.5",
        resize: "vertical",
      }}
      onFocus={(e) =>
        (e.currentTarget.style.border = `1px solid ${reduxTheme.primary_colors[800]}`)
      }
      onBlur={(e) =>
        (e.currentTarget.style.border = `1px solid ${reduxTheme.grey_colors[500]}`)
      }
    />
  );
};

export default ResizableTextarea;
